export const Update_Permissions_KEY: string = 'permissionsUpdated';
export const Map_Resize_KEY: string = 'mapResize';
